export enum InputMode {
  /** 手动输入 */
  Input = 'input',
  /** 智能生成 */
  AI = 'ai',
  /** Prompt */
  Prompt = 'prompt',
  /** 语音识别 */
  Audio = 'audio',
}

export enum AiTaskStatus {
  Pending = 'pending', // 解析中
  Running = 'running', // 进行中
  Success = 'success', // 任务成功
  Failed = 'failed', // 任务失败
}

export enum TranslateCommand {
  All,
  Current,
}
